import React, { useEffect } from 'react'
import Helmet from 'react-helmet'

import { usePage, useForm, router } from '@inertiajs/react'
import { toast } from 'react-toastify'

import Layout from '@/Shared/Layout'
import TrashedMessage from '@/Shared/TrashedMessage'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import Form from '@/Pages/Hospitals/Shared/Form'

const Edit = () => {
    const { hospital } = usePage().props;

    const { data, setData, errors, put, processing } = useForm({
        name: hospital.name || '',
        district_id: hospital.district_id,
        division_id: hospital.division_id
    });

    useEffect(() => {
        Object.values(errors).map(error => {
            toast.error(error)
        })
    }, [errors])

    function handleSubmit(e) {
        e.preventDefault()
        put(route('hospitals.update', hospital.id))
    }

    function destroy() {
        if (confirm('Are you sure you want to delete this record?')) {
            router.delete(route('hospitals.destroy', hospital.id))
        }
    }

    function restore() {
        if (confirm('Are you sure you want to restore this record?')) {
            router.put(route('hospitals.restore', hospital.id))
        }
    }

    return (
        <div>
            <Helmet title={`${data.name}`} />

            <BreadCrumbs link="hospitals" title="Hospitals" subTitle="Edit" />

            <h1 className="mb-8 text-3xl font-bold">Edit {data.name}</h1>

            {hospital.deleted_at && (
                <TrashedMessage onRestore={restore}>
                    This hospital has been deleted.
                </TrashedMessage>
            )}

            <div className="max-w-3xl overflow-y-visible rounded bg-white p-8 shadow">
                <h1 className="text-2xl font-semibold">Hospital Form</h1>

                <Form
                    data={data}
                    setData={setData}
                    errors={errors}
                    processing={processing}
                    handleSubmit={handleSubmit}
                    isEdit
                    deleted_at={hospital.deleted_at}
                    destroy={destroy}
                />

            </div>
        </div>
    )
}

Edit.layout = page => <Layout children={page} />

export default Edit
